import type { RouteRecordNameGeneric } from 'vue-router'

import { routeAutoRepeatsHome } from '@/routers/routes/mainRoutes/routeAccountings/autoRepeatsRoutes.ts'
import { routeDunningsHome } from '@/routers/routes/mainRoutes/routeAccountings/dunningRoutes.ts'
import { routePaymentEntriesHome } from '@/routers/routes/mainRoutes/routeAccountings/paymentEntriesRoutes.ts'
import { routePurchaseInvoicesHome } from '@/routers/routes/mainRoutes/routeAccountings/puchaseInvoiceRoutes.ts'
import { routeSalesInvoicesHome } from '@/routers/routes/mainRoutes/routeAccountings/salesInvoiceRoutes.ts'
import { routeInboxHome } from '@/routers/routes/mainRoutes/routeActivities/communicationRoutes'
import { routeTodosHome } from '@/routers/routes/mainRoutes/routeActivities/todoRoutes.ts'
import { routePurchaseOrdersHome } from '@/routers/routes/mainRoutes/routeBuying/purchaseOrderRoutes'
import { routeRequestForQuotationsHome } from '@/routers/routes/mainRoutes/routeBuying/requestForQuotationRoutes'
import { routeSupplierQuotationsHome } from '@/routers/routes/mainRoutes/routeBuying/supplierQuotationRoutes'
import { routeFilesHome } from '@/routers/routes/mainRoutes/routeFileSystem/filesRoutes.ts'
import { routeEmployeesHome } from '@/routers/routes/mainRoutes/routeHR/employeeRoutes.ts'
import { routeMarketingCampaignsHome } from '@/routers/routes/mainRoutes/routeMarketing/marketingCampaignRoutes'
import { routeDistributionListsHome } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/distributionListRoutes'
import { routeNewsletterArticlesHome } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/newsletterArticleRoutes'
import { routeSubscribersHome } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/subscriberRoutes'
import { routeDeliveryNotesHome } from '@/routers/routes/mainRoutes/routeProjects/deliveryNoteRoutes.ts'
import { routeProjectsHome } from '@/routers/routes/mainRoutes/routeProjects/projectRoutes.ts'
import { routeTasksHome } from '@/routers/routes/mainRoutes/routeProjects/taskRoutes.ts'
import { routeTimesheetsHome } from '@/routers/routes/mainRoutes/routeProjects/timesheetRoutes.ts'
import { routeDealsHome } from '@/routers/routes/mainRoutes/routeSales/dealsRoutes.ts'
import { routeQuotationsHome } from '@/routers/routes/mainRoutes/routeSales/quotationsRoutes.ts'
import { routeSalesOrdersHome } from '@/routers/routes/mainRoutes/routeSales/salesOrdersRoutes.ts'
import { routeActivityTypesHome } from '@/routers/routes/mainRoutes/routeServices/activityTypesRoutes.ts'
import { routeItemsHome } from '@/routers/routes/mainRoutes/routeServices/routeItems/itemsRoutes.ts'
import { routeSerialNosHome } from '@/routers/routes/mainRoutes/routeServices/routeItems/serialNoRoutes'
import { routeItemPricesHome } from '@/routers/routes/mainRoutes/routeServices/routePrices/itemPricesRoutes.ts'
import { routePriceListsHome } from '@/routers/routes/mainRoutes/routeServices/routePrices/priceListRoutes.ts'
import { routePricingRulesHome } from '@/routers/routes/mainRoutes/routeServices/routePrices/pricingRuleRoutes.ts'
import { routeUOMHome } from '@/routers/routes/mainRoutes/routeServices/uomRoutes.ts'
import { routeCurrencySettingsHome } from '@/routers/routes/mainRoutes/routeSettings/currencyRoutes'
import { routeDataImportHome } from '@/routers/routes/mainRoutes/routeSettings/dataImportRoutes.ts'
import { routeLetterheadHome } from '@/routers/routes/mainRoutes/routeSettings/letterheadRoutes.ts'
import { routePrintFormatsHome } from '@/routers/routes/mainRoutes/routeSettings/printFormatRoutes.ts'
import { routeAccountsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/accountsRoutes.ts'
import { routeCostCenterHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/costCenterRoutes.ts'
import { routeDatevSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/datevSettingsRoutes.ts'
import { routeDunningPlanHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/dunningPlanRoutes.ts'
import { routeDunningTypesHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/dunningTypesRoutes.ts'
import { routeManagementReportRowsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/managementReportRowRoutes.ts'
import { routeManagementReportSummaryRowsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/managementReportSummaryRowRoutes.ts'
import { routePaymentTermsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/paymentTermsRoutes.ts'
import { routePaymentTermsTemplatesHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/paymentTermsTemplatesRoutes.ts'
import { routeVatReturnRowsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/vatReturnRowRoutes.ts'
import { routeNotificationsHome } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/notificationRoutes.ts'
import { routeSlackHome } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/slackRoutes.ts'
import { routeCustomerGroupSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/customerGroupRoutes'
import { routePhoneTypeSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/phoneTypeRoutes.ts'
import { routeRoleSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/roleRoutes.ts'
import { routeSalutationSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/salutationRoutes'
import { routeSupplierGroupSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/supplierGroupRoutes'
import { routeWeblinkTypeSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/weblinkTypeRoutes.ts'
import { routeConnectedAppHome } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/connectedAppRoutes'
import { routeEmailAccountHome } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailAccountRoutes'
import { routeEmailDomainHome } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailDomainRoutes'
import { routeEmailTemplateHome } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailTemplateRoutes'
import { routeTokenCacheHome } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/tokenCacheRoutes'
import { routeGoogleCalendarHome } from '@/routers/routes/mainRoutes/routeSettings/routeGoogle/googleCalendarRoutes.ts'
import { routeGoogleSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeGoogle/googleSettingsRoutes.ts'
import { routeWebhookHome } from '@/routers/routes/mainRoutes/routeSettings/routeInterfaces/webhookRoutes.ts'
import { routeBuyingCenterRoleSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/routeSales/buyingCenterRoleRoutes'
import { routeQuotationLostReasonHome } from '@/routers/routes/mainRoutes/routeSettings/routeSales/quotationLostReasonRoutes'
import { routeSystemSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/systemSettingsRoutes.ts'
import { routeTagHome } from '@/routers/routes/mainRoutes/routeSettings/tagsRoutes.ts'
import { routeTermsAndConditionsSettingsHome } from '@/routers/routes/mainRoutes/routeSettings/termsAndConditionsSettingRoutes'
import { routeUsersHome } from '@/routers/routes/mainRoutes/routeSettings/usersRoutes.ts'
import { routePurchaseReceiptsHome } from '@/routers/routes/mainRoutes/routeStock/purchaseReceiptsRoutes'
import { routeStockEntriesHome } from '@/routers/routes/mainRoutes/routeStock/stockEntriesRoutes'
import { routeWarehousesHome } from '@/routers/routes/mainRoutes/routeStock/warehousesRoutes'

const listRouteMap: Record<string, RouteRecordNameGeneric> = {
  Account: routeAccountsHome.name,
  'Activity Type': routeActivityTypesHome.name,
  'Auto Repeat': routeAutoRepeatsHome.name,
  Communication: routeInboxHome.name,
  'Connected App': routeConnectedAppHome.name,
  'Cost Center': routeCostCenterHome.name,
  Currency: routeCurrencySettingsHome.name,
  'Customer Group': routeCustomerGroupSettingsHome.name,
  'Data Import': routeDataImportHome.name,
  'DATEV Unternehmen Online Settings': routeDatevSettingsHome.name,
  'Delivery Note': routeDeliveryNotesHome.name,
  Dunning: routeDunningsHome.name,
  'Dunning Plan': routeDunningPlanHome.name,
  'Dunning Type': routeDunningTypesHome.name,
  'Email Account': routeEmailAccountHome.name,
  'Email Domain': routeEmailDomainHome.name,
  'Email Group': routeDistributionListsHome.name,
  'Email Group Member': routeSubscribersHome.name,
  'Email Template': routeEmailTemplateHome.name,
  Employee: routeEmployeesHome.name,
  File: routeFilesHome.name,
  'Google Calendar': routeGoogleCalendarHome.name,
  'Google Settings': routeGoogleSettingsHome.name,
  Item: routeItemsHome.name,
  'Item Price': routeItemPricesHome.name,
  'Letter Head': routeLetterheadHome.name,
  'Marketing Campaign': routeMarketingCampaignsHome.name,
  Newsletter: routeNewsletterArticlesHome.name,
  Notification: routeNotificationsHome.name,
  Opportunity: routeDealsHome.name,
  'Payment Entry': routePaymentEntriesHome.name,
  'Payment Term': routePaymentTermsHome.name,
  'Payment Terms Template': routePaymentTermsTemplatesHome.name,
  'Price List': routePriceListsHome.name,
  'Pricing Rule': routePricingRulesHome.name,
  'Print Format': routePrintFormatsHome.name,
  Project: routeProjectsHome.name,
  'Purchase Invoice': routePurchaseInvoicesHome.name,
  'Purchase Order': routePurchaseOrdersHome.name,
  'Purchase Receipt': routePurchaseReceiptsHome.name,
  Quotation: routeQuotationsHome.name,
  'Quotation Lost Reason': routeQuotationLostReasonHome.name,
  'Request for Quotation': routeRequestForQuotationsHome.name,
  'Sales Invoice': routeSalesInvoicesHome.name,
  'Sales Order': routeSalesOrdersHome.name,
  Salutation: routeSalutationSettingsHome.name,
  'Serial No': routeSerialNosHome.name,
  'Slack Webhook URL': routeSlackHome.name,
  'Stock Entry': routeStockEntriesHome.name,
  'Supplier Group': routeSupplierGroupSettingsHome.name,
  'Supplier Quotation': routeSupplierQuotationsHome.name,
  'System Settings': routeSystemSettingsHome.name,
  Tag: routeTagHome.name,
  Task: routeTasksHome.name,
  'Terms and Conditions': routeTermsAndConditionsSettingsHome.name,
  Timesheet: routeTimesheetsHome.name,
  ToDo: routeTodosHome.name,
  'Token Cache': routeTokenCacheHome.name,
  'TW Buying Center Role': routeBuyingCenterRoleSettingsHome.name,
  'TW Management Report Row': routeManagementReportRowsHome.name,
  'TW Management Report Summary Row': routeManagementReportSummaryRowsHome.name,
  'TW Phone Type': routePhoneTypeSettingsHome.name,
  'TW Role': routeRoleSettingsHome.name,
  'TW VAT Return Row': routeVatReturnRowsHome.name,
  'TW Weblink Type': routeWeblinkTypeSettingsHome.name,
  UOM: routeUOMHome.name,
  User: routeUsersHome.name,
  Warehouse: routeWarehousesHome.name,
  Webhook: routeWebhookHome.name,
}

export default listRouteMap
